import * as i1 from '@abp/ng.core';
import { mapEnumToOptions } from '@abp/ng.core';
import * as i0 from '@angular/core';
import { Injectable } from '@angular/core';

var index$a = /*#__PURE__*/Object.freeze({
    __proto__: null
});

var LoginResultType;
(function (LoginResultType) {
    LoginResultType[LoginResultType["Success"] = 1] = "Success";
    LoginResultType[LoginResultType["InvalidUserNameOrPassword"] = 2] = "InvalidUserNameOrPassword";
    LoginResultType[LoginResultType["NotAllowed"] = 3] = "NotAllowed";
    LoginResultType[LoginResultType["LockedOut"] = 4] = "LockedOut";
    LoginResultType[LoginResultType["RequiresTwoFactor"] = 5] = "RequiresTwoFactor";
    LoginResultType[LoginResultType["NotLinked"] = 6] = "NotLinked";
})(LoginResultType || (LoginResultType = {}));
const loginResultTypeOptions = mapEnumToOptions(LoginResultType);

var index$9 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    get LoginResultType () { return LoginResultType; },
    loginResultTypeOptions: loginResultTypeOptions
});

let AccountService$1 = class AccountService {
    constructor(restService) {
        this.restService = restService;
        this.apiName = 'AbpAccountPublic';
        this.checkPasswordByLogin = (login, config) => this.restService.request({
            method: 'POST',
            url: '/api/account/checkPassword',
            body: login,
        }, { apiName: this.apiName, ...config });
        this.linkLoginByLogin = (login, config) => this.restService.request({
            method: 'POST',
            url: '/api/account/linkLogin',
            body: login,
        }, { apiName: this.apiName, ...config });
        this.loginByLogin = (login, config) => this.restService.request({
            method: 'POST',
            url: '/api/account/login',
            body: login,
        }, { apiName: this.apiName, ...config });
        this.logout = (config) => this.restService.request({
            method: 'GET',
            url: '/api/account/logout',
        }, { apiName: this.apiName, ...config });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.1.5", ngImport: i0, type: AccountService, deps: [{ token: i1.RestService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.1.5", ngImport: i0, type: AccountService, providedIn: 'root' }); }
};
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.1.5", ngImport: i0, type: AccountService$1, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: () => [{ type: i1.RestService }] });

var index$8 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    AccountService: AccountService$1,
    Models: index$9
});

var index$7 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    Controllers: index$8
});

var index$6 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    Account: index$7
});

var index$5 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    Areas: index$6
});

var index$4 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    Web: index$5
});

var index$3 = /*#__PURE__*/Object.freeze({
    __proto__: null
});

var index$2 = /*#__PURE__*/Object.freeze({
    __proto__: null
});

var index$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    Content: index$3,
    Identity: index$2
});

var index = /*#__PURE__*/Object.freeze({
    __proto__: null,
    Abp: index$1
});

class AccountExternalProviderService {
    constructor(restService) {
        this.restService = restService;
        this.apiName = 'AbpAccountPublic';
        this.getAll = (config) => this.restService.request({
            method: 'GET',
            url: '/api/account/external-provider',
        }, { apiName: this.apiName, ...config });
        this.getByName = (input, config) => this.restService.request({
            method: 'GET',
            url: '/api/account/external-provider/by-name',
            params: { tenantId: input.tenantId, name: input.name },
        }, { apiName: this.apiName, ...config });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.1.5", ngImport: i0, type: AccountExternalProviderService, deps: [{ token: i1.RestService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.1.5", ngImport: i0, type: AccountExternalProviderService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.1.5", ngImport: i0, type: AccountExternalProviderService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: () => [{ type: i1.RestService }] });

class AccountSessionService {
    constructor(restService) {
        this.restService = restService;
        this.apiName = 'AbpAccountPublic';
        this.get = (id, config) => this.restService.request({
            method: 'GET',
            url: `/api/account/sessions/${id}`,
        }, { apiName: this.apiName, ...config });
        this.getList = (input, config) => this.restService.request({
            method: 'GET',
            url: '/api/account/sessions',
            params: {
                device: input.device,
                clientId: input.clientId,
                sorting: input.sorting,
                skipCount: input.skipCount,
                maxResultCount: input.maxResultCount,
                extraProperties: input.extraProperties,
            },
        }, { apiName: this.apiName, ...config });
        this.revoke = (id, config) => this.restService.request({
            method: 'DELETE',
            url: `/api/account/sessions/${id}`,
        }, { apiName: this.apiName, ...config });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.1.5", ngImport: i0, type: AccountSessionService, deps: [{ token: i1.RestService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.1.5", ngImport: i0, type: AccountSessionService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.1.5", ngImport: i0, type: AccountSessionService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: () => [{ type: i1.RestService }] });

class AccountService {
    constructor(restService) {
        this.restService = restService;
        this.apiName = 'AbpAccountPublic';
        this.confirmEmail = (input, config) => this.restService.request({
            method: 'POST',
            url: '/api/account/confirm-email',
            body: input,
        }, { apiName: this.apiName, ...config });
        this.confirmPhoneNumber = (input, config) => this.restService.request({
            method: 'POST',
            url: '/api/account/confirm-phone-number',
            body: input,
        }, { apiName: this.apiName, ...config });
        this.getAuthenticatorInfo = (config) => this.restService.request({
            method: 'GET',
            url: '/api/account/authenticator-info',
        }, { apiName: this.apiName, ...config });
        this.getConfirmationState = (id, config) => this.restService.request({
            method: 'GET',
            url: '/api/account/confirmation-state',
            params: { id },
        }, { apiName: this.apiName, ...config });
        this.getProfilePicture = (id, config) => this.restService.request({
            method: 'GET',
            url: `/api/account/profile-picture/${id}`,
        }, { apiName: this.apiName, ...config });
        this.getProfilePictureFile = (id, config) => this.restService.request({
            method: 'GET',
            responseType: 'blob',
            url: `/api/account/profile-picture-file/${id}`,
        }, { apiName: this.apiName, ...config });
        this.getSecurityLogList = (input, config) => this.restService.request({
            method: 'GET',
            url: '/api/account/security-logs',
            params: { startTime: input.startTime, endTime: input.endTime, applicationName: input.applicationName, identity: input.identity, action: input.action, userName: input.userName, clientId: input.clientId, correlationId: input.correlationId, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount, extraProperties: input.extraProperties },
        }, { apiName: this.apiName, ...config });
        this.getTwoFactorProviders = (input, config) => this.restService.request({
            method: 'GET',
            url: '/api/account/two-factor-providers',
            params: { userId: input.userId, token: input.token },
        }, { apiName: this.apiName, ...config });
        this.hasAuthenticator = (config) => this.restService.request({
            method: 'GET',
            url: '/api/account/has-authenticator-key',
        }, { apiName: this.apiName, ...config });
        this.recaptchaByCaptchaResponse = (captchaResponse, config) => this.restService.request({
            method: 'GET',
            url: '/api/account/recaptcha-validate',
            params: { captchaResponse },
        }, { apiName: this.apiName, ...config });
        this.register = (input, config) => this.restService.request({
            method: 'POST',
            url: '/api/account/register',
            body: input,
        }, { apiName: this.apiName, ...config });
        this.resetAuthenticator = (config) => this.restService.request({
            method: 'POST',
            url: '/api/account/reset-authenticator',
        }, { apiName: this.apiName, ...config });
        this.resetPassword = (input, config) => this.restService.request({
            method: 'POST',
            url: '/api/account/reset-password',
            body: input,
        }, { apiName: this.apiName, ...config });
        this.sendEmailConfirmationToken = (input, config) => this.restService.request({
            method: 'POST',
            url: '/api/account/send-email-confirmation-token',
            body: input,
        }, { apiName: this.apiName, ...config });
        this.sendPasswordResetCode = (input, config) => this.restService.request({
            method: 'POST',
            url: '/api/account/send-password-reset-code',
            body: input,
        }, { apiName: this.apiName, ...config });
        this.sendPhoneNumberConfirmationToken = (input, config) => this.restService.request({
            method: 'POST',
            url: '/api/account/send-phone-number-confirmation-token',
            body: input,
        }, { apiName: this.apiName, ...config });
        this.sendTwoFactorCode = (input, config) => this.restService.request({
            method: 'POST',
            url: '/api/account/send-two-factor-code',
            body: input,
        }, { apiName: this.apiName, ...config });
        this.setProfilePicture = (input, config) => this.restService.request({
            method: 'POST',
            url: '/api/account/profile-picture',
            params: { type: input.type },
            body: input.imageContent,
        }, { apiName: this.apiName, ...config });
        this.verifyAuthenticatorCode = (input, config) => this.restService.request({
            method: 'POST',
            url: '/api/account/verify-authenticator-code',
            body: input,
        }, { apiName: this.apiName, ...config });
        this.verifyEmailConfirmationToken = (input, config) => this.restService.request({
            method: 'POST',
            url: '/api/account/verify-email-confirmation-token',
            body: input,
        }, { apiName: this.apiName, ...config });
        this.verifyPasswordResetToken = (input, config) => this.restService.request({
            method: 'POST',
            url: '/api/account/verify-password-reset-token',
            body: input,
        }, { apiName: this.apiName, ...config });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.1.5", ngImport: i0, type: AccountService, deps: [{ token: i1.RestService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.1.5", ngImport: i0, type: AccountService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.1.5", ngImport: i0, type: AccountService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: () => [{ type: i1.RestService }] });

class DynamicClaimsService {
    constructor(restService) {
        this.restService = restService;
        this.apiName = 'AbpAccountPublic';
        this.refresh = (config) => this.restService.request({
            method: 'POST',
            url: '/api/account/dynamic-claims/refresh',
        }, { apiName: this.apiName, ...config });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.1.5", ngImport: i0, type: DynamicClaimsService, deps: [{ token: i1.RestService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.1.5", ngImport: i0, type: DynamicClaimsService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.1.5", ngImport: i0, type: DynamicClaimsService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: () => [{ type: i1.RestService }] });

class IdentityLinkUserService {
    constructor(restService) {
        this.restService = restService;
        this.apiName = 'AbpAccountPublic';
        this.generateLinkLoginToken = (config) => this.restService.request({
            method: 'POST',
            responseType: 'text',
            url: '/api/account/link-user/generate-link-login-token',
        }, { apiName: this.apiName, ...config });
        this.generateLinkToken = (config) => this.restService.request({
            method: 'POST',
            responseType: 'text',
            url: '/api/account/link-user/generate-link-token',
        }, { apiName: this.apiName, ...config });
        this.getAllList = (config) => this.restService.request({
            method: 'GET',
            url: '/api/account/link-user',
        }, { apiName: this.apiName, ...config });
        this.isLinked = (input, config) => this.restService.request({
            method: 'POST',
            url: '/api/account/link-user/is-linked',
            body: input,
        }, { apiName: this.apiName, ...config });
        this.link = (input, config) => this.restService.request({
            method: 'POST',
            url: '/api/account/link-user/link',
            body: input,
        }, { apiName: this.apiName, ...config });
        this.unlink = (input, config) => this.restService.request({
            method: 'POST',
            url: '/api/account/link-user/unlink',
            body: input,
        }, { apiName: this.apiName, ...config });
        this.verifyLinkLoginToken = (input, config) => this.restService.request({
            method: 'POST',
            url: '/api/account/link-user/verify-link-login-token',
            body: input,
        }, { apiName: this.apiName, ...config });
        this.verifyLinkToken = (input, config) => this.restService.request({
            method: 'POST',
            url: '/api/account/link-user/verify-link-token',
            body: input,
        }, { apiName: this.apiName, ...config });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.1.5", ngImport: i0, type: IdentityLinkUserService, deps: [{ token: i1.RestService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.1.5", ngImport: i0, type: IdentityLinkUserService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.1.5", ngImport: i0, type: IdentityLinkUserService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: () => [{ type: i1.RestService }] });

class IdentityUserDelegationService {
    constructor(restService) {
        this.restService = restService;
        this.apiName = 'AbpAccountPublic';
        this.delegateNewUser = (input, config) => this.restService.request({
            method: 'POST',
            url: '/api/account/user-delegation/delegate-new-user',
            body: input,
        }, { apiName: this.apiName, ...config });
        this.deleteDelegation = (id, config) => this.restService.request({
            method: 'POST',
            url: '/api/account/user-delegation/delete-delegation',
            params: { id },
        }, { apiName: this.apiName, ...config });
        this.getActiveDelegations = (config) => this.restService.request({
            method: 'GET',
            url: '/api/account/user-delegation/active-delegations',
        }, { apiName: this.apiName, ...config });
        this.getDelegatedUsers = (config) => this.restService.request({
            method: 'GET',
            url: '/api/account/user-delegation/delegated-users',
        }, { apiName: this.apiName, ...config });
        this.getMyDelegatedUsers = (config) => this.restService.request({
            method: 'GET',
            url: '/api/account/user-delegation/my-delegated-users',
        }, { apiName: this.apiName, ...config });
        this.getUserLookup = (input, config) => this.restService.request({
            method: 'GET',
            url: '/api/account/user-delegation/user-lookup',
            params: { userName: input.userName },
        }, { apiName: this.apiName, ...config });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.1.5", ngImport: i0, type: IdentityUserDelegationService, deps: [{ token: i1.RestService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.1.5", ngImport: i0, type: IdentityUserDelegationService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.1.5", ngImport: i0, type: IdentityUserDelegationService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: () => [{ type: i1.RestService }] });

var ProfilePictureType;
(function (ProfilePictureType) {
    ProfilePictureType[ProfilePictureType["None"] = 0] = "None";
    ProfilePictureType[ProfilePictureType["Gravatar"] = 1] = "Gravatar";
    ProfilePictureType[ProfilePictureType["Image"] = 2] = "Image";
})(ProfilePictureType || (ProfilePictureType = {}));
const profilePictureTypeOptions = mapEnumToOptions(ProfilePictureType);

class ProfileService {
    constructor(restService) {
        this.restService = restService;
        this.apiName = 'AbpAccountPublic';
        this.canEnableTwoFactor = (config) => this.restService.request({
            method: 'GET',
            url: '/api/account/my-profile/can-enable-two-factor',
        }, { apiName: this.apiName, ...config });
        this.changePassword = (input, config) => this.restService.request({
            method: 'POST',
            url: '/api/account/my-profile/change-password',
            body: input,
        }, { apiName: this.apiName, ...config });
        this.get = (config) => this.restService.request({
            method: 'GET',
            url: '/api/account/my-profile',
        }, { apiName: this.apiName, ...config });
        this.getTimezones = (config) => this.restService.request({
            method: 'GET',
            url: '/api/account/my-profile/timezones',
        }, { apiName: this.apiName, ...config });
        this.getTwoFactorEnabled = (config) => this.restService.request({
            method: 'GET',
            url: '/api/account/my-profile/two-factor-enabled',
        }, { apiName: this.apiName, ...config });
        this.setTwoFactorEnabled = (enabled, config) => this.restService.request({
            method: 'POST',
            url: '/api/account/my-profile/set-two-factor-enabled',
            params: { enabled },
        }, { apiName: this.apiName, ...config });
        this.update = (input, config) => this.restService.request({
            method: 'PUT',
            url: '/api/account/my-profile',
            body: input,
        }, { apiName: this.apiName, ...config });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.1.5", ngImport: i0, type: ProfileService, deps: [{ token: i1.RestService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.1.5", ngImport: i0, type: ProfileService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.1.5", ngImport: i0, type: ProfileService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: () => [{ type: i1.RestService }] });

/**
 * Generated bundle index. Do not edit.
 */

export { AccountExternalProviderService, AccountService, AccountSessionService, DynamicClaimsService, index$a as ExternalProviders, IdentityLinkUserService, IdentityUserDelegationService, ProfilePictureType, ProfileService, index$4 as Public, index as Volo, profilePictureTypeOptions };
